<script>
import { IonFooter } from '@ionic/vue'

export default IonFooter
</script>

<style lang="scss">
.footer-md::before {
  background-image: none !important;
}
</style>
